export const takeEndDate = (
  startDate: Date,
  period: 'day' | 'week' | 'month'
) => {
  const date = new Date(startDate);

  switch (period) {
    case 'day':
      date.setDate(date.getDate() + 1);
      break;
    case 'week':
      date.setDate(date.getDate() + 7);
      break;
    case 'month':
      date.setMonth(date.getMonth() + 1);
      break;
    default:
      throw new Error('Invalid period. Use "day", "week", or "month".');
  }

  return date;
};
